import { render, staticRenderFns } from "./BottomBarMobile.vue?vue&type=template&id=cfb02ba4&scoped=true"
import script from "./BottomBarMobile.vue?vue&type=script&lang=js"
export * from "./BottomBarMobile.vue?vue&type=script&lang=js"
import style0 from "./BottomBarMobile.vue?vue&type=style&index=0&id=cfb02ba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb02ba4",
  null
  
)

export default component.exports